import './polyfill';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { WalletProvider } from 'providers/WalletProvider';
import { BrowserRouter } from 'react-router-dom';
import { DeviceProvider } from 'providers/DeviceProvider';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <WalletProvider>
      <BrowserRouter>
        <DeviceProvider>
          <App />
        </DeviceProvider>
      </BrowserRouter>
    </WalletProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
